import { render, staticRenderFns } from "./NextListingCourse.vue?vue&type=template&id=4ace260e"
import script from "./NextListingCourse.vue?vue&type=script&lang=js"
export * from "./NextListingCourse.vue?vue&type=script&lang=js"
import style0 from "./NextListingCourse.vue?vue&type=style&index=0&id=4ace260e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports